export default {
    'advances_held': 'Advances held',
    'billed': 'Billed',
    'x_invoice_s': '{invoiceCount} invoice(s)',
    'paid': 'Paid',
    'owing': 'Owing',
    'credit': 'Credit',
    'statement_of_account': 'Statement of account',
    'refund_advance': 'Refund advance',
    'collect_advance': 'Collect advance',
    'no_advances_have_been_taken_for_this_admission': 'No advances have been taken for this admission.',
    'when': 'When',
    'receipt': 'Receipt',
    'type': 'Type',
    'mode': 'Mode',
    'reference': 'Reference',
    'taken_by': 'Taken by',
    'no_shift': 'no shift',
    'amount': 'Amount',
    'print_receipt': 'Print receipt',
    'print_receipt_on_a4': 'Print receipt on A4',
    'advance_refunded': 'Advance refunded',
    'advance_recorded': 'Advance recorded',
    'receipt_x': 'Receipt {receiptNo}',
    'a4_receipt': 'A4 receipt',
    'thermal_receipt': 'Thermal receipt',
    'done': 'Done',
    'paid_back': 'paid back',
    'received': 'received',
    'by': 'by',
    'refund_an_advance': 'Refund an advance',
    'collect_an_advance': 'Collect an advance',
    'only_what_is_left_after_the_bill_is_settled_and': 'Only what is left after the bill is settled, and only the way it was paid.',
    'held_as_a_liability_until_it_is_applied_to_the': 'Held as a liability until it is applied to the bill.',
    'cancel': 'Cancel',
    'refund': 'Refund',
    'record_advance': 'Record advance',
    'kind': 'Kind',
    'advance': 'Advance',
    'top_up': 'Top-up',
    'the_card_slip_transfer_or_wallet_reference': 'The card slip, transfer or wallet reference',
    'reason': 'Reason',
    'note': 'Note',
    'close': 'Close',
    'reject': 'Reject',
    'approve': 'Approve',
    'you_cannot_approve_this_yet': 'You cannot approve this yet',
    'required_to_reject_kept_with_the_record_and': 'Required to reject. Kept with the record and shown to the person who asked.',
    'your_role_can_ask_for_this_but_cannot_decide_it': 'Your role can ask for this but cannot decide it. A supervisor approves or rejects it.',
    'billing': 'Billing',
    'invoices_and_their_outstanding_balances': 'Invoices and their outstanding balances',
    'new_invoice': 'New invoice',
    'all_statuses': 'All statuses',
    'invoice_number_patient_name_or_mrn': 'Invoice number, patient name or MRN',
    'no_invoices_match': 'No invoices match.',
    'invoice': 'Invoice',
    'patient': 'Patient',
    'walk_in': 'Walk-in',
    'context': 'Context',
    'payer': 'Payer',
    'date': 'Date',
    'status': 'Status',
    'total': 'Total',
    'balance': 'Balance',
    'estimate_saved_and_sent_for_discount_approval': 'Estimate saved and sent for discount approval',
    'invoice_created': 'Invoice created',
    'estimate_saved': 'Estimate saved',
    'prices_resolve_from_the_patients_category_and': 'Prices resolve from the patient\'s category and payer price list',
    'save_as_estimate': 'Save as estimate',
    'create_and_issue': 'Create & issue',
    'leave_blank_for_a_walk_in_sale': 'Leave blank for a walk-in sale',
    'services': 'Services',
    'add_line': 'Add line',
    'nothing_is_in_the_charge_master_yet_over_the': 'Nothing is in the charge master yet. Over-the-counter sales are billed at the Pharmacy counter; this screen is for services you price yourself.',
    'add_at_least_one_service': 'Add at least one service.',
    'select_a_service': 'Select a service…',
    'search_services_by_name_or_code': 'Search services by name or code',
    'no_service_matches_x': 'No active service matches "{value}"',
    'type_more_to_narrow_the_list': 'Showing the first matches; type more to narrow the list',
    'disc': 'Disc %',
    'remove_line': 'Remove line',
    'reason_for_discount': 'Reason for discount',
    'required_whenever_a_discount_is_applied': 'Required whenever a discount is applied',
    'estimated_total_list_prices': 'Estimated total (list prices)',
    'discount_above_your_limit': 'Discount above your limit',
    'send_for_approval_instead': 'Send for approval instead',
    'billing_settings': 'Billing settings',
    'cash_shifts_and_payment_rules': 'Cash, shifts and payment rules',
    'loading': 'Loading…',
    'you_can_view_these_settings_but_not_change_them': 'You can view these settings but not change them.',
    'charge_master': 'Services & prices',
    'services_their_list_prices_and_the_tariffs_that': 'Services, their list prices and the price lists that override them',
    'add_service': 'Add service',
    'add_tariff': 'Add price list',
    'add_package': 'Add package',
    'tariffs': 'Price lists',
    'packages': 'Packages',
    'consultation_fees': 'Consultation fees',
    'search_services': 'Search services',
    'all_categories': 'All categories',
    'set_your_prices_the_starter_services_were_added': 'Set your prices. The starter services were added without prices because list prices differ by country and hospital.',
    'orders_need_prices': '{count, plural, one {# order needs a price before it can be done in-house} other {# orders need prices before they can be done in-house}}',
    'orders_need_prices_hint': 'Lab tests, imaging and procedures without a price cannot be billed when they are done here.',
    'show_services_without_price': 'Show them',
    'price_filter': 'Price',
    'any_price': 'Any price',
    'needs_price': 'Needs price',
    'no_services_in_the_charge_master_yet': 'No services in the charge master yet.',
    'code': 'Code',
    'service': 'Service',
    'category': 'Category',
    'department': 'Department',
    'tax': 'Tax',
    'list_price': 'List price',
    'no_tariffs_defined': 'No price lists defined.',
    'tariff': 'Price list',
    'applies_to': 'Applies to',
    'priority': 'Priority',
    'priced_services': 'Priced services',
    'no_packages_defined': 'No packages defined.',
    'package': 'Package',
    'fixed_price': 'Fixed price',
    'beyond_the_package': 'Beyond the package',
    'billed_on_top': 'billed on top',
    'absorbed': 'absorbed',
    'package_kind': 'Kind of package',
    'package_kind_invoice_bundle': 'Bundle added to a bill',
    'package_kind_health_checkup': 'Health check-up',
    'package_kind_ipd_stay': 'Inpatient package',
    'package_kind_session_bundle': 'Session bundle',
    'package_kind_hint_invoice_bundle': 'Added to a bill at the counter: each service is billed at once and the lines add up to the package price.',
    'package_kind_hint_health_checkup': 'Sold for one outpatient visit. The consultation and tests it lists are billed inside the package, and its tests are ordered when the patient arrives.',
    'package_kind_hint_ipd_stay': 'Attached to one admission at a fixed price. The bed days, theatre, medicines and services it lists post at no charge up to their quantities.',
    'package_kind_hint_session_bundle': 'Sessions paid in advance on their own bill, used one per visit until the package expires.',
    'package_items_hint_health_checkup': 'How many of each the check-up covers. Any consultation of the visit counts as the consultation listed here.',
    'package_items_hint_ipd_stay': 'How many of each the stay covers, for example 3 days of a ward bed or 1 theatre session.',
    'package_items_hint_session_bundle': 'How many sessions of each service the bundle holds.',
    'included_quantity': 'Included',
    'x_days': '{count, plural, one {# day} other {# days}}',
    'nr_title': 'Ready to send to the insurer?',
    'nr_intro': 'What the insurer will receive and what is still missing. Red items stop the request; amber ones are worth fixing first.',
    'nr_ready': 'Ready to send',
    'nr_not_ready': 'Not ready to send',
    'nr_blocking_count': '{count, plural, one {# item stops the request} other {# items stop the request}}',
    'nr_warning_count': '{count, plural, one {# item is worth checking} other {# items are worth checking}}',
    'nr_in_place_count': '{count, plural, one {# item is in place} other {# items are in place}}',
    'nr_show_in_place': 'Show what is in place',
    'nr_hide_in_place': 'Hide what is in place',
    'nr_details_title': 'Admission details for the insurer',
    'nr_priority': 'Admission priority',
    'nr_priority_elective': 'Elective',
    'nr_priority_urgent': 'Urgent',
    'nr_priority_emergency': 'Emergency',
    'nr_service_event': 'Service event',
    'nr_service_event_hint': 'Initial for a new condition; subsequent when the stay continues care already given for it',
    'nr_service_event_ICSE': 'Initial',
    'nr_service_event_SCSE': 'Subsequent',
    'nr_estimated_stay': 'Estimated stay (days)',
    'nr_admission_estimate': 'Admission cost estimate',
    'nr_save': 'Save',
    'nr_saved': 'Saved',
    'nr_could_not_save': 'Could not save',
    'nr_attach': 'Attach a file',
    'nr_attached': 'File attached',
    'nr_could_not_attach': 'Could not attach the file',
    'nr_send': 'Send to the insurer',
    'nr_close': 'Close',
    'nr_fix_first': 'Fix the red items before sending.',
    'nr_no_draft': 'No request for this stay is waiting to be sent.',
    'nr_open_admission': 'Open the admission',
    'nr_open_patient': 'Open the patient record',
    'nr_open_pre_authorization': 'Edit the request',
    'nr_open_user': 'Open the doctor’s record',
    'nr_open_specialty': 'Open the specialty',
    'nr_open_bed': 'Open the bed',
    'nr_open_code_mapping': 'Open code mapping',
    'nr_open_branch': 'Open the branch',
    'nr_open_integration_settings': 'Open integration settings',
    'nr_open_encounter': 'Open the consultation',
    'nr_open_lab_catalogue': 'Open the lab catalogue',
    'nr_source_opd': 'Outpatient clinic',
    'nr_source_er': 'Emergency department',
    'nr_source_direct': 'Direct admission',
    'nr_source_transfer_in': 'Transfer from another facility',
    'nr_vital_name_systolic': 'Blood pressure (systolic)',
    'nr_vital_name_diastolic': 'Blood pressure (diastolic)',
    'nr_vital_name_pulse': 'Pulse',
    'nr_vital_name_respiratoryRate': 'Respiratory rate',
    'nr_vital_name_temperature': 'Temperature',
    'nr_vital_name_spo2': 'Oxygen saturation',
    'nr_vital_name_height': 'Height',
    'nr_vital_name_weight': 'Weight',
    'nr_patient_identifier_ok': 'The patient’s national ID or Iqama is on file',
    'nr_patient_identifier_missing': 'The patient has no national ID or Iqama number',
    'nr_patient_id_type_ok': 'The kind of identity document is known',
    'nr_patient_id_type_missing': 'The kind of identity document is not recorded',
    'nr_patient_occupation_ok': 'Occupation is recorded',
    'nr_patient_occupation_missing': 'Occupation is not recorded',
    'nr_patient_nationality_ok': 'Nationality is recorded',
    'nr_patient_nationality_missing': 'Nationality is not recorded',
    'nr_branch_licence_ok': 'Sent under provider licence {licence}',
    'nr_branch_licence_missing': 'The branch has no NPHIES provider licence',
    'nr_branch_location_ok': 'The branch location licence is set',
    'nr_branch_location_missing': 'The branch location licence is not set',
    'nr_practitioner_licence_ok': 'Treating doctor {name}, licence {licence}',
    'nr_practitioner_licence_missing': 'The treating doctor has no registration number on file',
    'nr_practitioner_practice_code_ok': 'Practice code {code}',
    'nr_practitioner_practice_code_missing': 'The doctor’s specialty has no NPHIES practice code',
    'nr_diagnosis_ok': 'A principal diagnosis is recorded',
    'nr_diagnosis_missing': 'No diagnosis is recorded',
    'nr_lab_loinc_missing': '{count, plural, one {# lab result has} other {# lab results have}} no LOINC code and will not go with the claim: {names}',
    'nr_chief_complaint_ok': 'The chief complaint is recorded',
    'nr_chief_complaint_missing': 'No chief complaint is recorded',
    'nr_vital_ok': '{vital} will be sent',
    'nr_vital_missing': '{vital}: no value and no reason it was not taken',
    'nr_estimated_stay_ok': 'Estimated stay {count, plural, one {# day} other {# days}}',
    'nr_estimated_stay_missing': 'No estimated length of stay',
    'nr_lines_ok': '{count, plural, one {# line} other {# lines}} to send',
    'nr_lines_missing': 'There is nothing to send',
    'nr_coverage_ok': 'Policy {policyNo}',
    'nr_coverage_missing': 'The patient has no active policy with this payer',
    'nr_eligibility_ok': 'The policy was checked recently',
    'nr_eligibility_not_eligible': 'The last check said the patient is not eligible',
    'nr_eligibility_stale': 'The policy has not been checked with the insurer recently',
    'nr_deadline_ok': 'Send by {date}',
    'nr_deadline_overdue': 'The payer’s window closed on {date}',
    'nr_admission_ok': 'Admission {number}',
    'nr_admission_missing': 'The request is not linked to an admission',
    'nr_consultant_licence_ok': 'Primary consultant {name}, licence {licence}',
    'nr_consultant_licence_missing': 'The primary consultant has no registration number on file',
    'nr_specialty_code_ok': 'Admitting specialty {specialty}, practice code {code}',
    'nr_specialty_code_missing': 'The admitting specialty has no NPHIES practice code',
    'nr_icd_ok': 'Principal diagnosis {code} - {title}',
    'nr_icd_missing': 'The request has no principal ICD-10 diagnosis',
    'nr_priority_ok': 'Admission priority: {priority}',
    'nr_priority_missing': 'The admission priority is not recorded',
    'nr_source_ok': 'Admitted from: {source}',
    'nr_source_missing': 'Where the patient was admitted from is not recorded',
    'nr_service_event_ok': 'Service event: {type}',
    'nr_service_event_missing': 'The service event type is not recorded',
    'nr_intended_stay_ok': 'Intended stay: {stay}',
    'nr_disposition_ok': 'Discharge disposition: {disposition}',
    'nr_disposition_missing': 'Where the patient went at discharge is not recorded',
    'nr_discharge_specialty_ok': 'Discharge specialty {specialty}, practice code {code}',
    'nr_discharge_specialty_missing': 'The discharge specialty has no NPHIES practice code',
    'nr_cause_of_death_ok': 'Cause of death {code}',
    'nr_cause_of_death_missing': 'The patient died but no coded cause of death is recorded',
    'nr_reason_ok': 'Reason for admission: {text}',
    'nr_reason_missing': 'No reason for admission: there is no chief complaint, provisional diagnosis or admission note',
    'nr_accommodation_ok': 'Accommodation: {service}, insurer code {code}',
    'nr_accommodation_no_bed_charge': 'The patient’s bed has no daily accommodation charge',
    'nr_accommodation_no_line': 'The request has no accommodation line for the bed',
    'nr_accommodation_unmapped': 'The accommodation service {service} has no insurer billing code',
    'nr_codes_ok': 'Every service has an insurer billing code',
    'nr_codes_missing': '{count, plural, one {# service has} other {# services have}} no insurer billing code: {names}',
    'nr_amount_ok': 'Estimated cost {amount}',
    'nr_amount_missing': 'The estimated cost of the request is zero',
    'nr_estimate_ok': 'Close to the admission estimate of {estimate}',
    'nr_estimate_differs': 'The request asks for {requested}; the admission estimate is {estimate}',
    'nr_estimate_missing': 'The admission has no cost estimate',
    'nr_attachments_ok': '{count, plural, one {# file goes} other {# files go}} with the request',
    'nr_attachments_missing': 'No files are attached; the insurer may ask for the admission notes or reports',
    'one_admission': 'One admission',
    'beyond_refused': 'refused',
    'offered_at': 'Offered at',
    'offered_at_hint': 'A branch package is sold and used only at that branch.',
    'all_branches': 'All branches',
    'offered_for_sale': 'Offered for sale',
    'a_code_of_at_least_two_characters': 'a code of at least two characters',
    'a_name': 'a name',
    'at_least_one_service_in_the_package': 'at least one service in the package',
    'the_price_the_patient_pays': 'the price the patient pays',
    'how_many_days_it_can_be_used': 'how many days it can be used',
    'package_price_hint_sold': 'What the patient pays. It is billed as one line, and the tax follows the category below.',
    'billed_as_service_x': 'Billed as service {code}; its price lists and insurer code are set on the Services tab.',
    'beyond_included': 'Beyond what it includes',
    'beyond_included_hint': 'When the patient needs more of a service than the package holds',
    'bill_it_normally': 'Bill it normally, outside the package',
    'refuse_it_at_the_counter': 'Refuse it at the counter',
    'claim_the_package_price_from_the_insurer': 'Claim the package price from the insurer',
    'package_claim_hint': 'Off: an insured patient pays the package price themselves.',
    'validity_days': 'Valid for (days)',
    'validity_days_hint': 'Counted from the day it is sold, that day included.',
    'attach_package': 'Attach package',
    'sell_package': 'Sell package',
    'no_packages_for_this_patient': 'No packages yet.',
    'package_status_active': 'Active',
    'package_status_consumed': 'Used up',
    'package_status_expired': 'Expired',
    'package_status_cancelled': 'Cancelled',
    'valid_until_x': 'Valid until {date}',
    'for_this_admission': 'For this admission',
    'sold_on_bill_x': 'Sold on bill {number}',
    'used_worth_x': 'Used worth {amount}',
    'used_x_of_y_left_z': '{used} of {included} used, {left} left',
    'credited_x': 'Credited {amount}',
    'credit_x_waiting_for_approval': 'Credit of {amount} waiting for approval',
    'cancel_package': 'Cancel package',
    'keep_package': 'Keep package',
    'package_sold': 'Package sold and billed',
    'package_cancelled': 'Package cancelled',
    'sell_and_bill': 'Sell and bill',
    'no_packages_of_this_kind': 'No package of this kind is offered at this branch.',
    'valid_for_x_days': 'Valid for {count, plural, one {# day} other {# days}}',
    'not_included_x': 'Not included: {text}',
    'used_at_list_prices': 'Used, at list prices',
    'to_credit_back': 'To credit back',
    'package_cancel_rule': 'The credit is the package price less what was used, at list prices, and never less than nothing. It follows the credit note approval limits.',
    'what_to_do_with_the_credit': 'What to do with the credit',
    'refund_what_was_paid': 'Refund what was paid',
    'keep_it_as_credit': 'Keep it as credit',
    'reduce_the_bill_only': 'Only reduce the bill',
    'package_sale': 'Package',
    'in_package': 'In package',
    'outside_package': 'Outside package',
    'packages_on_this_bill': 'Packages on this bill',
    'sold_on_this_bill_for_x': 'Sold on this bill for {amount}',
    'sold_on_another_bill': 'Sold on another bill',
    'used': 'Used',
    'left': 'Left',
    'list_value_x': 'List value {amount}',
    'inpatient_package': 'Inpatient package',
    'no_package': 'No package',
    'health_checkup_package': 'Health check-up',
    'add_check_up': 'Check-up',
    'check_up_x': 'Check-up: {name}',
    'service_updated': 'Service updated',
    'service_added': 'Service added',
    'edit_service': 'Edit service',
    'save': 'Save',
    'name': 'Name',
    'printed_beside_the_english_name_on_bilingual': 'Printed beside the English name on bilingual invoices',
    'lab_test_details': 'Lab test details',
    'lab_test_details_hint': 'What the Laboratory needs to collect this test and enter its result',
    'lab_section': 'Lab section',
    'turnaround_hours': 'Turnaround (hours)',
    'imaging_details': 'Imaging details',
    'imaging_details_hint': 'How Radiology books and performs this study',
    'body_part': 'Body part',
    'needs_contrast': 'Needs contrast',
    'needs_an_appointment': 'Needs an appointment',
    'linked_lab_test_x': 'Linked to lab test {code} in the Laboratory catalogue',
    'linked_lab_panel_x': 'This service is the lab panel {code}. Its tests are chosen in the Laboratory catalogue.',
    'linked_imaging_study_x': 'Linked to imaging study {code} in the Radiology catalogue',
    'new_lab_test_x': 'Saving adds it to the Laboratory catalogue as {code}',
    'new_imaging_study_x': 'Saving adds it to the Radiology catalogue as {code}',
    'price_required_procedure': 'Procedures are performed here, so they need a price.',
    'price_required_lab': 'The Laboratory module is on, so a lab test needs a price before it can be done here.',
    'price_required_radiology': 'The Radiology module is on, so imaging needs a price before it can be done here.',
    'price_optional_lab': 'Without the Laboratory module, lab tests are sent to outside laboratories, so a price is optional.',
    'price_optional_radiology': 'Without the Radiology module, imaging is done at outside centres, so a price is optional.',
    'enter_a_price_above_zero': 'Enter a price above zero',
    'tax_2': 'Tax %',
    'benefit_category': 'Benefit category',
    'how_an_insurance_policy_groups_this_service_for': 'How an insurance policy groups this service for its own co-pay and limits',
    'the_doctors_share_of_this_service_is_set_in': 'The doctor’s share of this service is set in Accounts →',
    'doctor_share': 'Doctor share',
    'tariff_updated': 'Price list updated',
    'tariff_added': 'Price list added',
    'rates_saved': 'Rates saved',
    'rate_removed': 'Rate removed',
    'that_service_falls_back_to_its_list_price': 'That service falls back to its list price',
    'edit_tariff': 'Edit price list',
    'a_tariff_prices_services_for_a_payer_or_a': 'A price list prices services for a payer or a patient category; the lowest priority number wins',
    'still_needed': 'Still needed:',
    'save_tariff': 'Save price list',
    'create_tariff': 'Create price list',
    'the_patient_categories_this_tariff_prices': 'The patient categories this price list prices',
    'needs_the_payer_master_permission': 'Needs the payer master permission',
    'leave_empty_for_a_category_tariff': 'Leave empty for a category price list',
    'plan': 'Plan',
    'only_patients_on_this_plan_of_the_payer_get': 'Only patients on this plan of the payer get these prices',
    'every_plan_of_this_payer': 'Every plan of this payer',
    'branch': 'Branch',
    'leave_empty_for_every_branch': 'Leave empty for every branch',
    'every_branch': 'Every branch',
    'valid_from': 'Valid from',
    'leave_empty_to_start_at_once': 'Leave empty to start at once',
    'valid_until': 'Valid until',
    'leave_empty_for_no_end_after_it_the_next_price': 'Leave empty for no end; after it the next price list applies',
    'lower_wins_a_payer_contract_outranks_a_category': 'Lower wins; a payer contract outranks a category either way',
    'active': 'Active',
    'price_with_this_tariff': 'Price under this price list',
    'rates_under_this_tariff': 'Rates under this price list',
    'rate': 'rate',
    'no_services_match': 'No services match.',
    'this_tariff': 'This price list',
    'new_rate': 'New rate',
    'remove': 'Remove',
    'create_the_tariff_first_then_reopen_it_to_set': 'Create the price list first, then reopen it to set the rates under it.',
    'package_updated': 'Package updated',
    'package_added': 'Package added',
    'edit_package': 'Edit package',
    'one_fixed_price_covering_a_set_of_services': 'One fixed price covering a set of services',
    'save_package': 'Save package',
    'create_package': 'Create package',
    'package_price': 'Package price',
    'anything_beyond_the_package': 'Anything beyond the package',
    'what_happens_when_a_stay_runs_longer_than_the': 'What happens when a stay runs longer than the package covers',
    'bill_it_on_top': 'Bill it on top',
    'absorb_it_the_package_price_is_final': 'Absorb it — the package price is final',
    'what_is_included': 'What is included',
    'what_is_not_included': 'What is not included',
    'services_in_the_package': 'Services in the package',
    'chosen_list_value': 'chosen · list value',
    'quantity': 'Quantity',
    'opd_billing_settings_saved': 'OPD billing settings saved',
    'could_not_save_the_setting': 'Could not save the setting',
    'consultation_fee_is_charged': 'Consultation fee is charged',
    'pay_before_the_consultation': 'Pay before the consultation',
    'needs_the_fee_charged_at_booking_or_arrival': 'Needs the fee charged at booking or arrival',
    'paid_visit_not_attended': 'Paid visit not attended',
    'keep_the_quoted_price_for_days': 'Keep the quoted price for (days)',
    '0_bill_todays_price': '0: bill today\'s price',
    'give_the_token_only_after_the_fee_is_paid': 'Give the token only after the fee is paid',
    'could_not_switch_the_rule_off': 'Could not switch the rule off',
    'consultation_fee_rules': 'Consultation fee rules',
    'add_fee_rule': 'Add fee rule',
    'no_consultation_fee_is_set_for': 'No consultation fee is set for:',
    'their_visits_will_show_no_fee_set_until_a_rule': '. Their visits will show "No fee set" until a rule is added.',
    'no_fee_rules_the_old_cons_gen_cons_spec_and': 'No fee rules. The old CONS-GEN, CONS-SPEC and CONS-FU codes are used until a rule is added.',
    'doctor': 'Doctor',
    'visit': 'Visit',
    'charge_item': 'Charge item',
    'active_2': 'active',
    'off': 'off',
    'edit': 'Edit',
    'switch_off': 'Switch off',
    'change_fee_rule': 'Change fee rule',
    'the_most_specific_rule_wins_doctor_then': 'The most specific rule wins: doctor, then department, then the whole hospital; a visit type beats any type',
    'any_doctor': 'Any doctor',
    'any_department': 'Any department',
    'visit_type': 'Visit type',
    'any_visit': 'Any visit',
    'consultation_charge_item': 'Consultation charge item',
    'choose': 'Choose',
    'add_a_charge_item_in_the_consultation_category': 'Add a charge item in the consultation category first.',
    'follow_up_pricing_updated': 'Follow-up pricing updated',
    'could_not_change_follow_up_pricing': 'Could not change follow-up pricing',
    'follow_up_pricing': 'Follow-up pricing',
    'follow_ups_are_priced_by_the_rules_below': 'Follow-ups are priced by the rules below, counted from the last visit that was paid as new.',
    'follow_ups_use_the_old_free_window_setting': 'Follow-ups use the old free-window setting, which restarts from every free visit. Switch to rules to end that.',
    'go_back_to_the_old_free_window': 'Go back to the old free window',
    'use_follow_up_rules': 'Use follow-up rules',
    'add_follow_up_rule': 'Add follow-up rule',
    'no_follow_up_rules_under_rules_pricing_the_old': 'No follow-up rules. Under rules pricing, the old free-window days apply until a rule is added.',
    'rule': 'Rule',
    'change_follow_up_rule': 'Change follow-up rule',
    'the_most_specific_rule_wins_doctor_then_2': 'The most specific rule wins: doctor, then department, then the whole hospital',
    'window_days_after_the_paid_visit': 'Window (days after the paid visit)',
    'free_follow_ups': 'Free follow-ups',
    'blank_every_follow_up_in_the_window_is_free': 'Blank: every follow-up in the window is free',
    'later_follow_ups_at_of_the_fee': 'Later follow-ups at (% of the fee)',
    'most_follow_ups_per_paid_visit': 'Most follow-ups per paid visit',
    'blank_no_limit': 'Blank: no limit',
    'only_with_the_same_doctor': 'Only with the same doctor',
    'adjustment': 'Adjustment',
    'credit_note_x_issued': 'Credit note {number} issued',
    'credit_note_x_requested': 'Credit note {number} requested',
    'a_supervisor_will_decide_it': 'A supervisor will decide it.',
    'credit_note_against_x': 'Credit note against {number}',
    'reduces_what_the_invoice_is_worth_the_original': 'Reduces what the invoice is worth. The original lines stay on the bill as they were.',
    'issue_credit_note': 'Issue credit note',
    'ask_for_approval': 'Ask for approval',
    'credit_lines': 'Credit lines',
    'credit_an_amount': 'Credit an amount',
    'up_to': '· up to',
    'can_still_be_credited': 'can still be credited',
    'medicine_the_customer_brings_back_goes_through': 'Medicine the customer brings back goes through a pharmacy return. Use an amount for a price correction.',
    'every_line_on_this_invoice_has_already_been': 'Every line on this invoice has already been credited. Credit an amount instead.',
    'amount_to_credit': 'Amount to credit',
    'up_to_x_tax_comes_off_in_the_same_proportion': 'Up to {netMinor}. Tax comes off in the same proportion the invoice carries it.',
    'at_least_five_characters_it_is_printed_on_the': 'At least five characters. It is printed on the credit note.',
    'credit_total': 'Credit total',
    'of_which_tax': 'of which tax',
    'invoice_becomes': 'Invoice becomes',
    'the_customer_has_paid_x_more_than_the_new_total': 'The customer has paid {overpaid} more than the new total. What happens to it?',
    'refund_it_now_the_same_way_it_was_paid': 'Refund it now, the same way it was paid',
    'keep_it_as_credit_on_this_invoice': 'Keep it as credit on this invoice',
    'the_panel_share_moves_with_the_new_total_if_the': 'The panel share moves with the new total. If the patient ends up overpaid, refund it from the payments list afterwards.',
    'within_your_approval_limit_so_it_takes_effect': 'Within your approval limit, so it takes effect as soon as you submit.',
    'above_your_approval_limit_of_x_so_it_waits_for': 'Above your approval limit of {approvalLimitMinor}, so it waits for a supervisor to approve.',
    'you_cannot_approve_credit_notes_yourself_so_it': 'You cannot approve credit notes yourself, so it waits for a supervisor to approve.',
    'credit_customers': 'Credit customers',
    'named_customers_who_took_goods_or_services_on': 'Named customers who took goods or services on account and still owe money',
    'customer_name': 'Customer name',
    'owing_on_this_list': 'Owing on this list:',
    'no_customer_owes_anything_a_walk_in_sale_with_a': 'No customer owes anything. A walk-in sale with a name and a part payment appears here.',
    'customer': 'Customer',
    'phone': 'Phone',
    'open_sales': 'Open sales',
    'oldest': 'Oldest',
    'show_more': 'Show more',
    'could_not_print': 'Could not print',
    'payment_on_account_recorded': 'Payment on account recorded',
    'change_due_x': 'Change due: {changeMinor}',
    'print_statement': 'Print statement',
    'nothing_outstanding': 'Nothing outstanding.',
    'sale': 'Sale',
    'x_received': '{paidMinor} received',
    'change_to_return': 'Change to return:',
    'still_owing': 'Still owing:',
    'take_a_payment_on_account': 'Take a payment on account',
    'it_is_applied_to_the_oldest_open_sales_first': 'It is applied to the oldest open sales first, and each sale gets its own receipt.',
    'no_phone_pick_sales': 'There is no phone number on file for this customer, so tick the sales this payment is for.',
    'pick_at_least_one_sale': 'Tick at least one sale',
    'this_payment_settles': 'This payment settles',
    'settles_x_in_full': '{number}: {amount}, cleared',
    'settles_x_in_part': '{number}: {amount} of {balance}',
    'amount_above_owing_x': 'That is more than the {owing} owed on these sales',
    'all': 'All',
    'cash_tendered': 'Cash tendered',
    'optional': 'Optional',
    'record_payment': 'Record payment',
    'invoice_issued': 'Invoice issued',
    'could_not_issue_the_invoice': 'Could not issue the invoice',
    'loading_the_invoice': 'Loading the invoice…',
    'that_invoice_could_not_be_opened': 'That invoice could not be opened.',
    'a4_bill': 'A4 bill',
    'statement': 'Statement',
    'credit_note': 'Credit note',
    'issue_invoice': 'Issue invoice',
    'collect_payment': 'Collect payment',
    'this_is_an_estimate_nothing_can_be_paid_against': 'This is an estimate. Nothing can be paid against it until it is issued as an invoice.',
    'cancelled': 'Cancelled',
    'the_bill_is_kept_for_the_record_and_nothing_is': '. The bill is kept for the record and nothing is owing on it.',
    'the_insurers_share_was_limited': 'The insurer’s share was limited',
    'this_bill_was_sent_to_a_payer_on_a_claim_so_it': 'This bill was sent to a payer on a claim, so it cannot be cancelled, credited or have lines removed. Corrections go through the claim.',
    'charges': 'Charges',
    'description': 'Description',
    'credited': 'Credited',
    'returned': 'Returned',
    'qty': 'Qty',
    'rate_2': 'Rate',
    'discount': 'Discount',
    'vat': 'VAT',
    'delete_x': 'Delete {description}',
    'payments': 'Payments',
    'no_payments_recorded_yet': 'No payments recorded yet.',
    'received_2': 'Received',
    'refunded': 'refunded',
    'refund_waiting': 'refund waiting',
    'refunds': 'Refunds',
    'requested': 'Requested',
    'voucher': 'Voucher',
    'print_refund_voucher': 'Print refund voucher',
    'credit_notes': 'Credit notes',
    'number': 'Number',
    'print_credit_note': 'Print credit note',
    'summary': 'Summary',
    'mrn': 'MRN',
    'gross': 'Gross',
    'net': 'Net',
    'panel_share': 'Panel share',
    'patient_share': 'Patient share',
    'credit_held_for_customer': 'Credit held for customer',
    'discount_reason': 'Discount reason:',
    'line_deleted': 'Line deleted',
    'delete_a_line_charged_in_error': 'Delete a line charged in error',
    'delete_line': 'Delete line',
    'only_for_a_charge_that_should_never_have_been': 'Only for a charge that should never have been made, on a bill with no payments. Once anything is paid, use a credit note instead. The deletion and your reason are kept in the audit log.',
    'at_least_five_characters': 'At least five characters',
    'payment_recorded': 'Payment recorded',
    'change_due_x_2': 'Change due: {change}',
    'received_by': 'received by',
    'balance_on_x_x': 'Balance on {number}: {balanceMinor}',
    'optional_used_to_compute_change': 'Optional — used to compute change',
    'the_card_slip_transfer_or_wallet_reference_most': 'The card slip, transfer or wallet reference. Most hospitals require it.',
    'transaction_or_slip_number': 'Transaction or slip number',
    'change_to_return_x': 'Change to return: {change}',
    'exact_amount_tendered': 'Exact amount tendered',
    'payment_amount_not_a_number': 'Enter the amount as a number, such as 1500 or 1500.50',
    'payment_amount_above_zero': 'Enter an amount more than zero',
    'payment_amount_above_balance_x': 'That is more than the balance of {balance}',
    'tendered_not_a_number': 'Enter the cash handed over as a number',
    'tendered_less_than_amount_x': 'The cash handed over is {short} less than the amount being paid',
    'vat_borne_by_the_state_saudi_citizen': 'VAT borne by the State — Saudi citizen /',
    'vat_changed_on_the_line': 'VAT changed on the line',
    'change_the_vat_on_a_line': 'Change the VAT on a line',
    'change_vat': 'Change VAT',
    'only_on_a_bill_with_no_payments_the_change_and': 'Only on a bill with no payments. The change and your reason are kept in the audit log and printed on the invoice.',
    'tax_category': 'Tax category',
    'for_example_citizen_id_card_not_shown': 'For example: citizen ID card not shown',
    'could_not_close_the_waiver_request': 'Could not close the waiver request',
    'decline_waiver_title': 'Decline the waiver',
    'decline_waiver_description': 'Why is the waiver declined? The reason is kept with the request.',
    'opd_dues': 'OPD dues',
    'visits_with_something_for_the_patient_to_pay': 'Visits with something for the patient to pay, and doctors\' waiver requests',
    'your_account_has_no_branch_ask_an_administrator': 'Your account has no branch; ask an administrator to set one.',
    'nothing_is_due_for_this_day': 'Nothing is due for this day.',
    'token': 'Token',
    'due': 'Due',
    'waiver': 'Waiver',
    'waiver_asked': 'waiver asked',
    'collect': 'Collect',
    'slip': 'Slip',
    'discount_applied': 'Discount applied',
    'decline': 'Decline',
    'next_page': 'Next page',
    'seen_but_not_billed': 'Seen but not billed',
    'every_completed_visit_of_this_day_has_its': 'Every completed visit of this day has its consultation charge.',
    'time': 'Time',
    'why': 'Why',
    'refunds_and_credit_notes': 'Refunds and credit notes',
    'money_handed_back_to_patients_and_reductions_of': 'Money handed back to patients, and reductions of a bill already issued',
    'waiting_for_approval': 'Waiting for approval',
    'paid_out': 'Paid out',
    'rejected': 'Rejected',
    'claims_tile_open': 'Open claims',
    'claims_tile_outstanding': 'Outstanding',
    'claims_tile_past_tat': 'Past payer TAT',
    'no_claims_match': 'No claims match.',
    'payment_mode': 'Payment mode',
    'every_mode': 'Every mode',
    'from_date': 'From date',
    'to_date': 'To date',
    'no_refunds_match': 'No refunds match.',
    'bill': 'Bill',
    'original_payment': 'Original payment',
    'no_receipt_no': 'no receipt no.',
    'taken_in': 'Taken in:',
    'decision_note': 'Decision note:',
    'staff': 'staff',
    'blocked': 'Blocked:',
    'review': 'Review',
    'print_voucher': 'Print voucher',
    'refund_approved_and_paid_out': 'Refund approved and paid out',
    'refund_approved_not_paid_out_yet': 'Refund approved, not paid out yet',
    'refund_rejected': 'Refund rejected',
    'refund_of_x': 'Refund of {amountMinor}',
    'bill_x': 'Bill {number}',
    'asked_for_by': 'Asked for by',
    'reason_given': 'Reason given',
    'already_refunded_from_it': 'Already refunded from it',
    'payment_was_taken_in': 'Payment was taken in',
    'your_approval_limit': 'Your approval limit',
    'paid_out_from': 'Paid out from',
    'applied': 'Applied',
    'no_credit_notes_match': 'No credit notes match.',
    'then': 'Then',
    'credit_note_approved': 'Credit note approved',
    'credit_note_rejected': 'Credit note rejected',
    'credit_note_x': 'Credit note {number}',
    'against_bill_x': 'Against bill {number}',
    'vat_in_it': 'VAT in it',
    'what_happens_next': 'What happens next',
    'refund_requested': 'Refund requested',
    'refund_a_payment': 'Refund a payment',
    'only_x_was_paid_above_this_bill_a_refund_for': 'Only {overpaidMinor} was paid above this bill. A refund for services goes through a credit note; at the desk you can return up to that amount, or reverse the whole payment ({paymentMinor}).',
    'nothing_was_paid_above_this_bill_a_refund_for': 'Nothing was paid above this bill. A refund for services goes through a credit note; at the desk you can only reverse the whole payment ({paymentMinor}).',
    'raise_a_credit_note_instead': 'Raise a credit note instead',
    'x_payment_of_x_on_x': '{mode} payment of {amountMinor} on {invoiceNumber}',
    'refund_now': 'Refund now',
    'amount_to_refund': 'Amount to refund',
    'up_to_x_can_still_be_refunded_from_this_payment': 'Up to {refundableMinor} can still be refunded from this payment',
    'at_least_five_characters_it_is_printed_on_the_2': 'At least five characters. It is printed on the refund voucher.',
    'within_your_approval_limit_so_it_is_approved': 'Within your approval limit, so it is approved and paid out straight away.',
    'you_cannot_approve_refunds_yourself_so_it_waits': 'You cannot approve refunds yourself, so it waits for a supervisor to approve.',
    'this_is_a_cash_refund_and_you_have_no_open': 'This is a cash refund and you have no open cashier shift. It only goes through if the shift that took the payment is still open; otherwise open your own shift first.',
    'shift_opened': 'Shift opened',
    'could_not_open_the_shift': 'Could not open the shift',
    'shift_closed': 'Shift closed',
    'could_not_close_the_shift': 'Could not close the shift',
    'checking_your_shift': 'Checking your shift…',
    'cashier_shift': 'Cashier shift',
    'open_a_shift_before_taking_payments': 'Open a shift before taking payments',
    'open_a_shift': 'Open a shift',
    'opening_float': 'Opening float',
    'cash_already_in_the_drawer': 'Cash already in the drawer',
    'open_shift': 'Open shift',
    'shift_hero_title': 'Ready to start the shift?',
    'shift_hero_body': 'Count the cash already in the drawer, enter it as the float, and open the shift. Every payment you take until you close is tallied against it.',
    'counter': 'Counter',
    'count_the_float': 'Count the float by note',
    'float_total': 'Float to open with',
    'your_last_shifts': 'Your last shifts',
    'no_shifts_yet': 'You have not closed a shift yet.',
    'step_open': 'Open with a float',
    'step_take': 'Take payments',
    'step_close': 'Count and close',
    'step_open_hint': 'Say what cash is in the drawer before the first sale.',
    'step_take_hint': 'Cash, card and transfers are tallied by payment mode as you go.',
    'step_close_hint': 'Count the notes at the end; the variance is shown before you commit.',
    'balanced': 'Balanced',
    'over_by_x': 'Over by {amount}',
    'short_by_x': 'Short by {amount}',
    'x_opened_x_by_x': '{counterName} · opened {openedAt} by {name}',
    'collected': 'Collected',
    'x_payment_s': '{paymentCount} payment(s)',
    'invoices': 'Invoices',
    'expected_in_drawer': 'Expected in drawer',
    'advances_taken_and_refunded': 'Advances taken and refunded',
    'refunds_paid_out': 'Refunds paid out',
    'taken_so_far_by_payment_mode': 'Taken so far — by payment mode',
    'no_payments_yet_this_shift': 'No payments yet this shift.',
    'close_shift_count_the_drawer': 'Close shift — count the drawer',
    'counted': 'Counted',
    'count_the_drawer_without_looking_at_the_system': 'Count the drawer without looking at the system total. The expected amount and any difference are shown once the shift is closed.',
    'the_drawer_balances_exactly': 'The drawer balances exactly.',
    'close_shift': 'Close shift',
    'close_this_shift': 'Close this shift?',
    'notes_and_coins': 'Notes and coins',
    'variance': 'Variance',
    'loose_cash_other_amount': 'Loose cash / other amount',
    'loose_cash_hint': 'Cash that is not counted note by note, such as a sealed bundle or odd coins',
    'enter_an_amount_of_zero_or_more': 'Enter an amount of zero or more',
    'closing_with_an_empty_drawer': 'Nothing was counted. Close the shift only if the drawer really is empty.',
    'no_note_list_for_this_currency': 'There is no note list for this currency; enter the counted cash as one amount below.',
    'coin_x': 'Coin {value}',
    'open_a_statement_from_a_patient_a_visit_or_an': 'Open a statement from a patient, a visit or an admission.',
    'patient_record': 'Patient record',
    'thermal': 'Thermal',
    'print_a4': 'Print A4',
    'bills_from': 'Bills from',
    'to': 'to',
    'all_time': 'All time',
    'gathering_every_bill': 'Gathering every bill…',
    'this_statement_shows_the_latest': 'This statement shows the latest',
    'invoices_only_narrow_the_dates_to_see_the_rest': 'invoices only. Narrow the dates to see the rest.',
    'total_billed': 'Total billed',
    'patient_share_x': 'Patient share {patientShareMinor}',
    'x_refunded': '{refundedMinor} refunded',
    'amount_due': 'Amount due',
    'credit_refundable': 'Credit / refundable',
    'after_x_advance_held': 'after {depositsHeldMinor} advance held',
    'no_bills_in_this_scope': 'No bills in this scope.',
    'visit_order_lines': 'Orders of this visit',
    'visit_order_lines_hint': 'Where each test or procedure is done. Change it before the patient pays.',
    'order_line_paid': 'Paid',
    'order_line_awaiting_payment': 'Awaiting payment',
    'order_line_not_billed': 'Not billed',
    'order_line_outside': 'Outside',
    'order_line_done_here': 'Done here',
    'order_line_send_outside': 'Patient goes outside',
    'order_line_do_here': 'Do it here',
    'order_line_outside_title': 'Have {name} done outside?',
    'order_line_here_title': 'Do {name} here?',
    'order_line_outside_description': 'The unpaid bill line is removed and the order leaves the worklist. The doctor can print the requisition from the visit.',
    'order_line_here_description': 'It is billed on the visit and reaches the worklist once paid.',
    'order_line_switched': 'Updated',
    'order_line_could_not_switch': 'Could not change where it is done',
    'order_line_type_lab': 'Lab test',
    'order_line_type_radiology': 'Imaging',
    'order_line_type_procedure': 'Procedure',
    'order_lines_load_more': 'Load more',
    'panel': 'Panel',
    'payments_and_refunds': 'Payments and refunds',
    'nothing_paid_yet': 'Nothing paid yet.',
    'advances': 'Advances',
    'no_advances': 'No advances.',
    'every_change_keeps_its_reason_and_who_made_it': 'Every change keeps its reason and who made it. If the hospital uses the two-person rule, the change waits for a second person.',
    'save_change': 'Save change',
    'what_to_change': 'What to change',
    'on': 'On',
    'percentage': 'Percentage',
    'no_threshold_nothing_needs_a_second_person_0': 'No threshold: nothing needs a second person. 0: everything does.',
    'leave_on_every_branch_unless_one_branch_needs': 'Leave on every branch unless one branch needs its own figure',
    'at_least_5_characters_shown_in_the_history': 'At least 5 characters; shown in the history',
    'doctors': 'Doctors',
    'ward_charges': 'Ward charges',
    'history': 'History',
    'the_part_of_each_services_collected_money_paid': 'The part of each service\'s collected money paid to the doctor who performed it. A change starts on a date you choose; bills already raised keep the share they were billed with.',
    'doctor_revenue_share_is_not_enabled_for': 'Doctor revenue share is not enabled for',
    'this_branch': 'this branch',
    'your_branches': 'your branches',
    'shares_already_on_bills_stay_as_billed': '. Shares already on bills stay as billed.',
    'share': 'Share (%)',
    'rate_kind': 'Rate kind',
    'pct_of_collected': '% of collected',
    'fixed_per_unit': 'Fixed per unit',
    'amount_per_unit': 'Amount per unit',
    'x_per_unit': '{amount} / unit',
    'paid_per_unit_billed_as_the_money_is_collected': 'Paid per unit billed, as the money is collected',
    'enter_an_amount_per_unit': 'Enter an amount per unit',
    'use_the_doctors_own_rate': 'Use the doctor\'s own rate',
    'no_own_rate_from_this_date_contract_ended': 'No own rate from this date (contract ended)',
    'starts_on': 'Starts on',
    'today_or_later_bills_already_raised_are_never': 'Today or later; bills already raised are never changed',
    'contract_reference': 'Contract reference',
    'waiting_for_a_second_person': 'Waiting for a second person',
    'saved': 'Saved',
    'all_kinds': 'All kinds',
    'include_lab_radiology_pharmacy_and_bed_charges': 'Include lab, radiology, pharmacy and bed charges',
    'set_default_for_a_whole_category': 'Set default for a whole category',
    'no_services': 'No services.',
    'default_share': 'Default share',
    'doctors_with_own_rate': 'Doctors with own rate',
    'next_change': 'Next change',
    'default_share_x': 'Default share — {name}',
    'change': 'Change',
    'first_page': 'First page',
    'set_the_default_share_for_a_whole_category': 'Set the default share for a whole category',
    'sets_the_default_for_every_active_service_of': 'Sets the default for every active service of that kind. Doctors with their own rate keep it.',
    'doctors_x': 'Doctors — {name}',
    'no_doctors': 'No doctors.',
    'own_rate_for_this_service': 'Own rate for this service',
    'rate_for_all_x': 'Rate for all {category}',
    'scheduled': 'Scheduled',
    'why_this_share': 'Why this share?',
    'this_service': 'This service',
    'x_every_x_service': '{doctorName} — every {category} service',
    'whole_category': 'Whole category',
    'why_this_share_x': 'Why this share? — {doctorName}',
    'choose_a_doctor': 'Choose a doctor',
    'print_rate_card': 'Print rate card',
    'could_not_download': 'Could not download',
    'download_csv': 'Download CSV',
    'this_doctor_has_no_rates_of_their_own_the': 'This doctor has no rates of their own; the service defaults apply.',
    'share_2': 'Share',
    'from': 'From',
    'state': 'State',
    'no_ward_charge_is_credited_to_the_admitting': 'No ward charge is credited to the admitting doctor.',
    'ward_charge': 'Ward charge',
    'share_x': 'Share — {name}',
    'could_not_do_that': 'Could not do that',
    'nothing_is_waiting': 'Nothing is waiting.',
    'asked': 'Asked',
    'new_share': 'New share',
    'asked_by': 'Asked by',
    'withdraw': 'Withdraw',
    'no_changes_yet': 'No changes yet.',
    'value': 'Value',
    'by_2': 'By',
    'waiting_for_approval_2': 'waiting for approval',
    'people': 'People',
    'starting_values_by_role': 'Starting values by role',
    'approval_thresholds': 'Approval thresholds',
    'reports': 'Reports',
    'financial_authority': 'Financial authority',
    'who_may_give_a_discount_approve_a_refund_or_a': 'Who may give a discount, approve a refund or a credit note, and above what amount a second person has to agree.',
    'the_limits_from_the_staff_screens_are_still': 'The limits from the staff screens are still being carried over. They keep working as before in the meantime.',
    'two_person_rule_for_authority_changes': 'Two-person rule for authority changes',
    'two_person_rule_for_doctor_share_changes': 'Two-person rule for doctor share changes',
    'search_staff': 'Search staff',
    'show_everyone_not_only_staff_who_handle_money': 'Show everyone, not only staff who handle money',
    'show_approval_ceilings': 'Show approval ceilings',
    'set_for': 'Set for',
    'selected': 'selected',
    'nobody_here_handles_money_yet': 'Nobody here handles money yet.',
    'select_x': 'Select {name}',
    'person': 'Person',
    'super_admin_no_limit': 'Super Admin — no limit',
    'no_limit': 'no limit',
    'set_a_limit_for_x_people': 'Set a limit for {length} people',
    'current_values_and_recent_changes': 'Current values and recent changes',
    'limit': 'Limit',
    'recent_changes': 'Recent changes',
    'when_someone_first_receives_a_role_they_are': 'When someone first receives a role, they are given these values. It is a copy, so a later change to a role does not change people who already have it.',
    'no_roles': 'No roles.',
    'role': 'Role',
    'starting_values': 'Starting values',
    'none': 'none',
    'set_a_starting_value': 'Set a starting value',
    'starting_value_x': 'Starting value — {name}',
    'branch_figures': 'Branch figures',
    'confirm': 'Confirm',
    'authority_changes': 'Authority changes',
    'new_value': 'New value',
    'approve_this_change': 'Approve this change',
    'reject_this_change': 'Reject this change',
    'withdraw_your_change': 'Withdraw your change',
    'discounts_sent_for_approval': 'Discounts sent for approval',
    'no_discount_is_waiting': 'No discount is waiting.',
    'estimate': 'Estimate',
    'approve_this_discount': 'Approve this discount',
    'send_this_discount_back': 'Send this discount back',
    'send_back': 'Send back',
    'carried_over_review': 'Carried over — review',
    'setting': 'Setting',
    'for': 'For',
    'decided_by': 'Decided by',
    'to_2': 'To',
    'current_limits_csv': 'Current limits (CSV)',
    'discounts_given': 'Discounts given',
    'no_discounts_in_this_period': 'No discounts in this period.',
    'given_by': 'Given by',
    'approved_by': 'Approved by',
    'bills': 'Bills',
    'released_by_a_second_person': 'Released by a second person',
    'nothing_in_this_period': 'Nothing in this period.',
    'what': 'What',
    'no_discount_limit_applies_to_you': 'No discount limit applies to you.',
    'you_cannot_give_a_discount_yourself_a': 'You cannot give a discount yourself; a supervisor has to approve one.',
    'up_to_2': 'Up to',
    'without_approval': '% without approval',
    'above_that_a_supervisor_approves_it': '. Above that, a supervisor approves it.',
    'the_supervisor_signs_in_here_their_password_is': 'The supervisor signs in here. Their password is checked by the server and never stored with the bill.',
    'supervisor_username': 'Supervisor username',
    'supervisor_password': 'Supervisor password',
    'authenticator_code': 'Authenticator code',
    'only_if_the_supervisor_uses_two_factor_sign_in': 'Only if the supervisor uses two-factor sign-in',
    'books_lock_updated': 'Books lock updated',
    'could_not_change_the_lock': 'Could not change the lock',
    'books_locked_through': 'Books locked through',
    'no_day_open': 'no day (open)',
    'lock_through_this_day': 'Lock through this day',
    'open_the_books': 'Open the books',
    'accounting': 'Accounting',
    'ledgers_statements_and_the_entries_behind_them': 'Ledgers, statements and the entries behind them',
    'statements': 'Statements',
    'journals': 'Journals',
    'chart_of_accounts': 'Chart of accounts',
    'income': 'Income',
    'expenses': 'Expenses',
    'books_balance': 'Books balance',
    'assets_liabilities_equity': 'Assets = liabilities + equity',
    'investigate_before_closing': 'Investigate before closing',
    'profit_and_loss': 'Profit & loss',
    'nothing_posted_in_this_window': 'Nothing posted in this window.',
    'account': 'Account',
    'balance_sheet': 'Balance sheet',
    'nothing_on_the_sheet_yet': 'Nothing on the sheet yet.',
    'retained_earnings': 'Retained earnings',
    'total_equity': 'Total equity',
    'trial_balance': 'Trial balance',
    'no_postings_in_this_window': 'No postings in this window.',
    'debit': 'Debit',
    'debit_2': 'debit /',
    'credit_2': 'credit',
    'department_p_and_l': 'Department P&L',
    'expense': 'Expense',
    'all_sources': 'All sources',
    'export_csv': 'Export CSV',
    'post_a_voucher': 'Post a voucher',
    'memo': 'Memo',
    'voucher_posted': 'Voucher posted',
    'manual_voucher': 'Manual voucher',
    'debits_and_credits_must_balance_posted_entries': 'Debits and credits must balance; posted entries are reversed, never edited',
    'post': 'Post',
    'select_an_account': 'Select an account…',
    'account_added': 'Account added',
    'could_not_add_the_account': 'Could not add the account',
    'add_account': 'Add account',
    'no_chart_of_accounts': 'No chart of accounts.',
    'postable': 'Postable',
    'add_an_account': 'Add an account',
    'headings_group_only_postable_accounts_take': 'Headings group; only postable accounts take journal lines',
    'add': 'Add',
    'accepts_postings': 'Accepts postings',
    'doctor_payouts': 'Doctor payouts',
    'shares_computed_from_money_the_hospital_has': 'Shares computed from money the hospital has actually collected',
    'compute_a_period': 'Compute a period',
    'draft': 'Draft',
    'approved_unpaid': 'Approved, unpaid',
    'paid_this_list': 'Paid this list',
    'no_payouts_computed_yet': 'No payouts computed yet.',
    'period': 'Period',
    'gross_share': 'Gross share',
    'deductions': 'Deductions',
    'net_payable': 'Net payable',
    'approved_and_booked_to_the_ledger': 'Approved and booked to the ledger',
    'marked_paid': 'Marked paid',
    'could_not_update_the_payout': 'Could not update the payout',
    'payout_advice_x': 'Payout advice — {value}',
    'payout_advice': 'Payout advice',
    'add_adjustment': 'Add adjustment',
    'mark_paid': 'Mark paid',
    'paid_by': 'Paid by',
    'payment_reference': 'Payment reference',
    'reference_needed_for_cheque_transfer_or_wallet': 'Needed for a cheque, transfer or wallet payment',
    'marking_paid_clears_the_payable_against_cash_or_bank': 'Marking it paid clears the payable against cash or bank in the ledger.',
    'nothing_earned_in_this_period': 'Nothing earned in this period.',
    'where': 'Where',
    'items': 'Items',
    'collected_base': 'Collected base',
    'no_lines': 'No lines.',
    'base': 'Base',
    'adjustment_added': 'Adjustment added',
    'add_an_adjustment': 'Add an adjustment',
    'for_money_owed_that_no_bill_line_shows_such_as': 'For money owed that no bill line shows, such as a contract signed after its start date. Bills already raised are never re-priced.',
    'payout_computed': 'Payout computed',
    'recomputing_the_same_period_replaces_the_draft': 'Recomputing the same period replaces the draft',
    'compute_a_payout': 'Compute a payout',
    'only_collected_money_is_shared_from_the_patient': 'Only collected money is shared, from the patient and the panel alike',
    'compute': 'Compute',
    'select': 'Select…',
    'advances_clinic_charges_withholding': 'Advances, clinic charges, withholding',
    'departments': 'Departments',
    'duration': 'Duration',
    'ask_at_booking': 'Ask',
    'x_min': '{minutes} min',
    'nphies': 'NPHIES',
    'nphies_price': 'NPHIES price',
    'nphies_price_invalid': 'Enter an amount such as {example}',
    'claimable_through_nphies': 'Claimable through NPHIES',
    'the_price_nphies_payers_get_leave_it_empty': 'The price NPHIES payers get; leave it empty to charge the list price',
    'payer_price_lists_that_override_this_amount': 'Payer price lists that override this amount: {count}',
    'duration_minutes': 'Duration (minutes)',
    'zero_means_the_length_is_asked_for_at_booking': '0 means the length is asked for at booking',
    'no_departments': 'No departments',
    'x_departments': '{count} departments',
    'search_departments': 'Search departments',
    'the_first_department_chosen_is_where_revenue': 'The first department chosen is where revenue reports file this service',
    'auto': 'Auto',
    'maintained_from_the_services_tab': 'Maintained from the Services tab: set each service’s NPHIES amount there',
    'nphies_price_saved': 'NPHIES price saved',
    'nphies_setting_saved': 'NPHIES setting saved',
    'use_a_family_members_policy': 'Use a family member’s policy',
    'copies_the_policy_number_and_plan_from_a_linked': 'Copies the policy number and plan from a linked family member. The insurer still decides whether the dependant is covered.',
    'no_linked_family_member_has_an_active_policy': 'No linked family member has an active policy. Link the family on the patient record first.',
    'family_members_policy': 'Family member’s policy',
    'this_patient_is_the_holders': 'This patient is the holder’s…',
    'holder_child': 'Child',
    'holder_spouse': 'Spouse',
    'holder_parent': 'Parent',
    'holder_other': 'Other dependant',
    'policy_added_from_the_family': 'Policy added from the family',
    'could_not_add_the_policy': 'Could not add the policy',
    'loading_family_policies': 'Loading family policies',
    'add_policy': 'Add policy',
    'pricing': 'Pricing',
    'sum_of_the_services': 'Sum of the services',
    'sum': 'Sum',
    'the_price_follows_the_services_in_it_at_their': 'The price follows the services in it at their list prices, so a price change on a service changes the package.',
    'a_package_can_cost_less_than_its_services_never': 'A package can cost less than its services, never more; the difference is spread across them as a discount.',
    'contents_at_list_prices': 'Contents at list prices',
    'quote_total': 'Quote total',
    'nphies_quote': 'NPHIES quote',
    'priced_through_the_nphies_price_list_a_service': 'Priced through the NPHIES price list; a service without an NPHIES price counts at its list price.',
    'save_the_package_first_to_see_its_quote': 'Save the package first to see its quote.',
    'whole_units_only': 'Whole units only',
    'choose_a_package': 'Choose a package',
    'quote': 'Quote',
    'package_discount': 'Package discount',
    'add_to_bill': 'Add to bill',
    'no_packages_to_bill_yet': 'No packages to bill yet. Build one under Services & prices → Packages.',
    'remove_package': 'Remove package',
    'delete_the_whole_package': 'Delete the whole package',
    'a_package_is_removed_as_a_whole_every_service': 'A package is removed as a whole; every service in it comes off the bill together.',
    'package_removed': 'Package removed',
    'x_services': '{count} services',
    'add_at_least_one_service_or_package': 'Add at least one service or package.',
    'the_quote_uses_the_patients_category_and_payer': 'The quote uses the patient’s category and payer; the bill is priced the same way.',
    'consultation': 'Consultation',
    'appointment': 'Appointment',
    'insurance': 'Insurance',
    'policy': 'Policy',
    'authorisation': 'Authorisation',
    'no_policy_on_file_for_this_payer': 'No policy on file for this payer',
    'x_services_still_need_the_insurers_approval': '{count, plural, one {# service still needs} other {# services still need}} the insurer’s approval',
    'x_services_waiting_for_the_insurer': '{count, plural, one {# service is} other {# services are}} waiting for the insurer',
    'the_insurer_has_answered_for_every_service': 'The insurer has answered for every service',
    'answered_outside_nphies': 'Answered outside NPHIES',
    'locked_sent_for_authorisation': 'Sent to the insurer for authorisation; cancel the pre-authorisation first',
    'locked_in_a_draft_request': 'Held in a pre-authorisation draft; send or discard the draft first',
    'discard_preauth_draft_title': 'Discard this draft request?',
    'discard_preauth_draft_body': 'It was never sent to the insurer. Its lines become available to a new request.',
    'discard_draft': 'Discard draft',
    'discard_selected_preauths_title': '{count, plural, one {Discard # request that was never sent?} other {Discard # requests that were never sent?}}',
    'discard_selected_preauths_body': 'None of them reached the insurer. Their lines become available to a new request.',
    'discard_selected_preauths': 'Discard selected',
    'identity': 'Identity',
    'claim_rules': 'Claim rules',
    'legal_details': 'Legal details',
    'what_the_patient_pays': 'What the patient pays',
    'validity': 'Validity',
    'offered_at_x': 'Offered at {branch}',
    'more_rules': 'More rules',
    'new_rule': 'New rule',
    'map_a_service': 'Map a service',
    'membership': 'Membership',
    'cover_and_limits': 'Cover and limits',
    'request_details': 'Request details',
    'billed_lines': 'Billed lines',
    'medicines': 'Medicines',
    'payment': 'Payment',
    'amounts': 'Amounts',
    'outcome': 'Outcome',
    'extension': 'Extension',
    'the_request': 'The request',
    'your_reply': 'Your reply',
    'attachments': 'Attachments',
    'claim': 'Claim',
    'plans': 'Plans',
    'pre_authorisation_rules': 'Pre-authorisation rules',
    'service_mapping': 'Service mapping',
    'plans_rules_and_service_codes_of_this_payer': 'Plans, pre-authorisation rules and service codes of this payer',
    'that_record_could_not_be_opened': 'That record could not be opened.',
    'lines': 'Lines',
    'what_to_credit': 'What to credit',
    'source': 'Source',
    'month': 'Month',
    'direction': 'Direction',
    'age_measured_from': 'Age measured from',
    'these_settings_let_a_consultation_run_unpaid': 'With these settings a consultation can start and close without the fee paid. Charge the fee on arrival and block the consultation until paid to enforce payment.',
    'cash_and_payments': 'Cash and payments',
    'tax_rates': 'Tax rates',
    'tax_rates_by_branch_and_resident_kind': 'The rate charged on patient bills, per branch, for citizens of the branch country and for everyone else. A new set of rates applies from the date chosen; bills already issued keep theirs.',
    'citizen': 'Citizen',
    'non_citizen': 'Non-citizen',
    'applies_from': 'Applies from',
    'rates_in_force_from_x': 'Rates in force from {date}',
    'using_the_country_default_rates': 'This branch has no rates of its own yet; the country default is used.',
    'each_service_keeps_its_own_rate_until_set': 'Until a standard rate is set here, each service charges the rate stored on it.',
    'tax_rates_saved': 'Tax rates saved',
    'could_not_save_the_tax_rates': 'Could not save the tax rates',
    'save_tax_rates': 'Save tax rates',
    'rate_history': 'Rate history',
    'no_rates_have_been_set_for_this_branch': 'No rates have been set for this branch.',
    'the_tax_rate_comes_from_the_branch_tax_rates': 'The rate comes from the branch tax rates in Billing settings.',
    'doctors_with_a_discount_on_this_service': 'Doctors who perform this service at a reduced price. The discount comes off the list price before any payer price list, and the doctor share is worked out on the net.',
    'add_doctor': 'Add doctor',
    'no_doctor_discounts_on_this_service': 'No doctor has a discount on this service.',
    'discount_kind_fixed': 'Fixed amount',
    'discount_kind_percent': 'Percent',
    'price_after_discount': 'Price after discount',
    'doctor_discounts_saved': 'Doctor discounts saved',
    'could_not_save_the_doctor_discounts': 'Could not save the doctor discounts',
    'save_doctors': 'Save doctors',
    'benefit_category_other': 'Other',
    'benefit_category_name': 'Benefit category name',
    'required_when_nphies_is_in_use': 'Required while NPHIES is in use',
    'country_default': 'Country default',
    'doctor_discount': 'Doctor discount',
    'nx_added_after_approval': 'Services added after approval',
    'nx_added_after_approval_hint': 'These services were added after the insurer answered. They stay self-pay unless you send them to the insurer as a follow-up authorisation.',
    'nx_already_on_file': 'Already on file',
    'nx_answer_rejected': 'Rejected',
    'nx_answer_waiting': 'Waiting for an answer',
    'nx_answers': 'Answers',
    'nx_approved': 'Approved',
    'nx_approved_percent': 'Approved %',
    'nx_authorise': 'Authorise',
    'nx_awaiting_authorisation': 'Awaiting authorisation',
    'nx_branch_payer_description': 'Choose whether this branch offers the insurer, and set the details that apply only here.',
    'nx_branch_payer_removed': 'Branch setting removed',
    'nx_branch_payer_saved': 'Branch setting saved',
    'nx_branch_payer_title': '{payer} at this branch',
    'nx_branch_payers_hint': 'An insurer with no setting here is offered at every branch. Once an insurer is set up at any branch, it is offered only where it is switched on.',
    'nx_branch_payers_title': 'Insurers at this branch',
    'nx_branch_restrict_warning': 'From now on this insurer is offered only at branches where it is set up and switched on. Set it up at the other branches that need it.',
    'nx_cchi_number': 'CCHI number',
    'nx_check_eligibility': 'Check eligibility',
    'nx_checked': 'Checked',
    'nx_checked_at': 'Checked {when}',
    'nx_choice_follow_up': 'Send as follow-up authorisation',
    'nx_choice_self_pay': 'Self-pay',
    'nx_claim': 'Claim',
    'nx_claim_block_admission_open': 'The admission for bill {number} is still open. Discharge the patient before claiming.',
    'nx_claim_block_already_claimed': 'Bill {number} is already on a claim.',
    'nx_claim_block_encounter_open': 'The consultation for bill {number} is still open. Close it before claiming.',
    'nx_claim_block_not_billable': 'Bill {number} is not issued yet or was cancelled, so it cannot be claimed.',
    'nx_claim_block_nothing_approved': 'None of the services on bill {number} has an insurer approval to claim.',
    'nx_claim_block_unpaid': 'Bill {number} still has {due} to be paid by the patient. A claim can be made only after the bill is paid.',
    'nx_claim_created': 'Claim created',
    'nx_claim_ready': 'This bill is paid and the visit is closed. It can be claimed.',
    'nx_claim_auto_pending': 'Claim will be created automatically',
    'nx_claimed': 'Claimed',
    'nx_claims': 'Claims',
    'nx_collapse_all': 'Collapse all',
    'nx_copied': 'Copied',
    'nx_copy': 'Copy',
    'nx_copy_value': 'Copy this value',
    'nx_could_not_authorise': 'Could not send for authorisation',
    'nx_could_not_copy': 'Could not copy',
    'nx_could_not_expire': 'Could not end the eligibility',
    'nx_could_not_save_branch_payer': 'Could not save the branch setting',
    'nx_could_not_save_validity': 'Could not save the validity',
    'nx_could_not_use_policy': 'Could not use this policy',
    'nx_coverage': 'Coverage',
    'nx_coverage_not_offered_here': 'Some policies are hidden because the insurer is not offered at this branch.',
    'nx_covered': 'Covered',
    'nx_create_claim': 'Create claim',
    'nx_default_plan': 'Default plan',
    'nx_detail': 'Detail',
    'nx_edit': 'Edit',
    'nx_eligibility': 'Eligibility',
    'nx_eligibility_check_failed': 'The insurer could not be asked',
    'nx_eligibility_expired_now': 'Eligibility ended. The next authorisation asks the insurer again.',
    'nx_eligibility_expired_on': 'Eligibility expired on {date}',
    'nx_eligibility_never_checked': 'Eligibility not checked yet',
    'nx_eligibility_not_in_force': 'Not in force',
    'nx_eligibility_settings_hint': 'How long an eligibility answer from the insurer is trusted. It also ends at the end of the policy period and on 31 December, whichever comes first.',
    'nx_eligibility_settings_title': 'Eligibility validity',
    'nx_eligibility_state_expired': 'Expired',
    'nx_eligibility_state_never': 'Never checked',
    'nx_eligibility_state_valid': 'Valid',
    'nx_eligibility_valid_until': 'Eligibility valid until {date}',
    'nx_expand_all': 'Expand all',
    'nx_expire_now': 'Expire now',
    'nx_expire_now_description': 'The next authorisation will ask the insurer again. This is recorded in the audit trail.',
    'nx_expire_now_title': 'End this eligibility now?',
    'nx_follow_up': 'Follow-up',
    'nx_follow_up_failed': 'Could not send the follow-up',
    'nx_follow_up_sent': 'Follow-up authorisation sent',
    'nx_has_insurance_no_policy': 'Patient has insurance but no policy',
    'nx_in_force': 'In force',
    'nx_insurance_total': 'Insurance total',
    'nx_insurer_answers': 'Insurer answers',
    'nx_insurer_share': 'Insurer share',
    'nx_licence_override': 'Licence override',
    'nx_licence_override_hint': 'NPHIES provider licence for this branch, if it differs',
    'nx_limit_days': 'Valid for {days} days from the check',
    'nx_limit_service_period': 'Ends with the policy period',
    'nx_limit_year_end': 'Ends on 31 December',
    'nx_limited_by': 'Limited by',
    'nx_linked_pre_authorisation': 'From the pre-authorisation',
    'nx_load_more': 'Load more',
    'nx_locked_by_approval': 'Approved by the insurer: this service cannot be removed, cancelled, credited or reduced',
    'nx_locked_lines_note': '{count, plural, one {# service is} other {# services are}} approved by the insurer and locked. You can still add more services to this bill.',
    'nx_match_x_of_y': 'Match {current} of {total}',
    'nx_member': 'Member',
    'nx_message': 'Message',
    'nx_message_not_readable': 'This message cannot be opened here.',
    'nx_messages': 'Messages',
    'nx_messages_description': 'Requests sent to the insurer and the answers that came back. Kept on this server only.',
    'nx_messages_for_claim': 'Messages for claim {number}',
    'nx_messages_for_communication': 'Messages for this insurer request',
    'nx_messages_for_eligibility': 'Eligibility messages',
    'nx_messages_for_preauth': 'Messages for pre-authorisation {number}',
    'nx_messages_for_reconciliation': 'Messages for this payment notice',
    'nx_needs_confirming_by_authorised_staff': 'Needs someone who can confirm policies',
    'nx_next_match': 'Next match',
    'nx_no_claims': 'No claims for this patient.',
    'nx_no_default_plan': 'No default plan',
    'nx_no_eligibility_history': 'No eligibility checks for this patient.',
    'nx_no_lines': 'No lines.',
    'nx_no_matches': 'No matches',
    'nx_no_messages': 'No messages were exchanged for this record.',
    'nx_no_number_yet': 'No number yet',
    'nx_no_payers': 'No insurers on file.',
    'nx_no_policy_for_payer': 'No policy on file for {payer}.',
    'nx_no_preauths': 'No pre-authorisations for this patient.',
    'nx_no_response_yet': 'No response yet',
    'nx_no_sessions': 'This patient has no active policy.',
    'nx_not_offered': 'Not offered',
    'nx_not_set_up_here': 'Not set up here',
    'nx_nothing_to_authorise': 'Nothing on this visit is waiting to be authorised.',
    'nx_number': 'Number',
    'nx_offered': 'Offered',
    'nx_offered_at_this_branch': 'Offered at this branch',
    'nx_payer_code': 'Code',
    'nx_pick_patient_for_sessions': 'Patient',
    'nx_pick_patient_hint': 'Choose a patient to see the eligibility of their policies.',
    'nx_plan_not_matched': 'Plan not matched',
    'nx_policies_found': '{count, plural, one {Found # policy} other {Found # policies}}',
    'nx_policy_added': 'Policy added',
    'nx_policy_search_description': 'Asks the insurer which policies it holds for this patient. Use it only when the patient has insurance but no policy is on file, or the policy on file is not in force.',
    'nx_policy_search_failed': 'The policy search failed',
    'nx_policy_search_not_allowed': 'A policy search is not allowed for this patient and insurer.',
    'nx_policy_search_title': 'Find the patient’s policy',
    'nx_preauth_answers_title': 'Insurer answers for {number}',
    'nx_previous_match': 'Previous match',
    'nx_purpose_discovery': 'Policy search',
    'nx_purpose_validation': 'Eligibility check',
    'nx_reason_duplicate': 'Duplicate of another request',
    'nx_reason_excluded': 'Excluded from the policy',
    'nx_reason_limit_exceeded': 'Policy limit reached',
    'nx_reason_missing_information': 'Information missing',
    'nx_reason_not_covered': 'Not covered by the policy',
    'nx_reason_not_eligible': 'Patient not eligible',
    'nx_reason_preauth_required': 'Needs a pre-authorisation',
    'nx_reason_identifier_missing': 'Identifier missing',
    'nx_reason_provider_identifier_missing': 'Provider identifier missing',
    'nx_reason_service_not_on_plan': 'Service is not part of the plan',
    'nx_reason_documents_missing': 'Supporting documents missing',
    'nx_reason_expired': 'Expired',
    'nx_reason_policy_expired': 'Policy has expired',
    'nx_reason_approval_expired': 'Approval has expired',
    'nx_reason_member_not_found': 'Member not found at the insurer',
    'nx_reason_policy_inactive': 'Policy is not active',
    'nx_reason_out_of_network': 'Provider is out of network',
    'nx_reason_not_medically_necessary': 'Not considered medically necessary',
    'nx_reason_waiting_period': 'Within the policy waiting period',
    'nx_reason_late_submission': 'Sent after the time allowed',
    'nx_reason_pre_existing': 'Pre-existing condition',
    'nx_reason_quantity_exceeded': 'More than the quantity or frequency allowed',
    'nx_reason_invalid_code': 'Code is not valid',
    'nx_reasons': 'Reasons',
    'nx_remaining_days': '{count, plural, one {# day left} other {# days left}}',
    'nx_remaining_hours': '{count, plural, one {# hour left} other {# hours left}}',
    'nx_remaining_minutes': '{count, plural, one {# minute left} other {# minutes left}}',
    'nx_request': 'Request',
    'nx_request_sent': 'Request sent',
    'nx_requested': 'Requested',
    'nx_response': 'Response',
    'nx_response_id': 'Response id',
    'nx_response_received': 'Response received',
    'nx_search_for_policy': 'Search for the policy',
    'nx_search_in_message': 'Search in message',
    'nx_search_policies': 'Search policies',
    'nx_self_pay': 'Self-pay',
    'nx_self_pay_total': 'Self-pay total',
    'nx_send_follow_up': '{count, plural, one {Send # service as follow-up authorisation} other {Send # services as follow-up authorisation}}',
    'nx_sent_for_authorisation': 'Sent for authorisation',
    'nx_session_reused': 'Eligibility is still valid. No new check was needed.',
    'nx_set_up': 'Set up',
    'nx_show_raw': 'Show raw',
    'nx_submitted': 'Submitted',
    'nx_tab_eligibility': 'Eligibility',
    'nx_tab_payers_plans': 'Payers & plans',
    'nx_tab_polling': 'Polling',
    'nx_tab_settings': 'Insurance settings',
    'nx_use_this_policy': 'Use this policy',
    'nx_validity_days': 'Eligibility valid for (days)',
    'nx_validity_days_hint': 'Between {min} and {max} days. Default 30.',
    'nx_validity_days_invalid': 'Enter a whole number from {min} to {max}',
    'nx_validity_saved': 'Validity saved',
    'nx_view_claims': 'Claims',
    'nx_view_eligibility_history': 'Eligibility history',
    'nx_view_policies': 'Policies',
    'nx_view_preauths': 'Pre-authorisations',
    'nx_x_percent_approved': '{pct}% approved',
    'ins_0_30_days': '0–30 days',
    'ins_add_payer': 'Add payer',
    'ins_add_them_in_settings_code_mapping': 'Add them in Settings, Integrations, Code mapping. The claim cannot be sent until they are mapped.',
    'ins_age': 'Age',
    'ins_age_from_sent': 'Age from when it was sent',
    'ins_age_from_service_date': 'Age from the service date',
    'ins_amount_received': 'Amount received',
    'ins_answer': 'Answer',
    'ins_answer_by_x': '(answer by {date})',
    'ins_answer_the_request': 'Answer the request',
    'ins_answer_x': 'Answer {subject}',
    'ins_approved_amount': 'Approved amount',
    'ins_assemble_a_claim': 'Assemble a claim',
    'ins_bills_not_yet_claimed': 'Bills not yet claimed',
    'ins_cancel_the_claim': 'Cancel the claim',
    'ins_cancellation_sent': 'Cancellation sent',
    'ins_check_status': 'Check status',
    'ins_claim_a_period': 'Claim a period',
    'ins_claim_is_closed': 'This claim is closed.',
    'ins_claim_queued_with_monthly_batch': 'Claim queued with the monthly batch',
    'ins_claim_sent_to_insurer': 'Claim sent to the insurer',
    'ins_claim_updated': 'Claim updated',
    'ins_claim_x': 'Claim {number}',
    'ins_co_pay': 'Co-pay',
    'ins_could_not_open_message': 'Could not open the message',
    'ins_could_not_send_ready_claims': 'Could not send the ready claims',
    'ins_could_not_split_claim': 'Could not split the claim',
    'ins_hide_bills_not_yet_claimed': 'Hide bills not yet claimed',
    'ins_insurer_answered_over_nphies': 'The insurer has answered over NPHIES, so approval and rejection are not typed in here.',
    'ins_insurer_is_asking': 'The insurer is asking for something',
    'ins_insurer_pays': 'Insurer pays',
    'ins_invoice_total': 'Invoice total',
    'ins_left_out': 'Left out',
    'ins_mark_x': 'Mark {status}',
    'ins_more_waiting_press_again': 'More are waiting; press again for the next group',
    'ins_next_step': 'Next step',
    'ins_no': 'no',
    'ins_no_payers_on_file': 'No payers on file.',
    'ins_no_text': 'No text',
    'ins_not_required': 'Not required',
    'ins_not_sent': 'not sent',
    'ins_nothing_new_to_send': 'There is nothing new to send',
    'ins_nothing_outstanding_any_payer': 'Nothing outstanding with any payer.',
    'ins_nothing_ready_to_send': 'Nothing was ready to send',
    'ins_over_90': 'Over 90',
    'ins_page_description': 'Claims, policies and what the payers still owe',
    'ins_page_title': 'Insurance & panels',
    'ins_past_agreed_turnaround': '— past the agreed {days}-day turnaround.',
    'ins_past_tat': 'Past TAT',
    'ins_patient_pays': 'Patient pays',
    'ins_payments_insurer_reported': 'Payments the insurer reported for this claim',
    'ins_pharmacy_claim_x_drafted': 'Pharmacy claim {number} drafted',
    'ins_pre_auth': 'Pre-auth',
    'ins_preauth_number': 'Pre-authorisation number',
    'ins_record_a_payment_received': 'Record a payment received',
    'ins_rejection_reason': 'Rejection reason',
    'ins_required': 'Required',
    'ins_required_by_payers_preauth': 'Required by payers that demand a pre-auth',
    'ins_send_all_ready_claims': 'Send all ready claims (monthly batch)',
    'ins_send_it_anyway': 'Send it anyway',
    'ins_send_now_carries_x_lines': 'A send now carries {count, plural, one {# line} other {# lines}}',
    'ins_send_the_new_lines': 'Send the new lines',
    'ins_send_to_nphies': 'Send to NPHIES',
    'ins_send_with_monthly_batch': 'Send with the monthly batch',
    'ins_sent_with_monthly_batch': 'Sent with the monthly batch',
    'ins_services_no_insurer_code': 'These services have no insurer billing code yet',
    'ins_split_off_pharmacy_bills': 'Split off pharmacy bills',
    'ins_tab_aging': 'Aging',
    'ins_tab_insurer_requests': 'Insurer requests',
    'ins_tab_revenue_cycle': 'Revenue cycle',
    'ins_tat': 'TAT',
    'ins_the_insurer_answered': 'The insurer answered',
    'ins_what_did_payer_ask': 'What did the payer ask for?',
    'ins_what_insurer_said_line_by_line': 'What the insurer said, line by line',
    'ins_write_to_insurer_about_claim': 'Write to the insurer about this claim',
    'ins_x_claims_queued_deferred': '{count, plural, one {# claim queued to go at deferred priority} other {# claims queued to go at deferred priority}}',
    'ins_x_days_short': '{days} d',
    'ins_x_days_with_payer': '{count, plural, one {# day with the payer} other {# days with the payer}}',
    'ins_x_not_ready': '{count} not ready: {list}',
    'ins_x_of_y': '{approved} of {quantity}',
    'ins_x_pharmacy_bills_moved': '{count, plural, one {# pharmacy bill moved onto it} other {# pharmacy bills moved onto it}}',
    'ins_yes': 'yes',
    'follow_up_offer_valid_for_days': 'Follow-up offer is valid for (days)',
    'follow_up_offer_valid_for_days_hint': 'Counted from the day the doctor closes the consultation, 1 to 365. The doctor can change it for a patient.',
    'their_visits_will_show_no_fee_set_until_added_to_a_service': '. Their visits will show "No fee set" until they are added to a consultation service.',
    'where_the_consultation_fee_comes_from': 'Where the consultation fee comes from',
    'the_consultation_fee_is_the_price_of_the_service': 'The fee is the price of the consultation service that lists the doctor, less that doctor\'s own discount on the service. Add a doctor to a consultation service in the Doctors section of the service. A doctor who is on no consultation service is charged the standard consultation services (general or specialist).',
    'follow_ups_are_decided_by_the_doctor_at_close': 'A follow-up is decided by the doctor when closing the consultation: free, paid or discounted, and for how many days it holds. There are no follow-up rules to set here.',
    'bill_now': 'Bill now',
    'visit_billed': 'The consultation is billed',
    'could_not_bill_the_visit': 'Could not bill the visit',
    'billing_still_blocked': 'The fee still cannot be billed. Set a fee for the doctor or check the patient’s coverage, then try again.',
    'todays_visit_with_x': 'Today’s visit with {doctor}',
    'not_for_a_visit': 'Not for a visit',
    'a_bill_on_todays_visit_is_paid_before_the_consultation': 'A bill on today’s visit has to be paid before the doctor starts or closes the consultation.',
    'package_revenue': 'Package revenue',
    'until': 'Until',
    'show': 'Show',
    'per_package': 'Per package',
    'per_package_and_month': 'Per package and month',
    'run_report': 'Run report',
    'choose_the_period_and_run_the_report': 'Choose the period and run the report.',
    'packages_sold': 'Packages sold',
    'x_cancelled': '{count} cancelled',
    'sale_value': 'Sale value',
    'before_tax': 'Before tax',
    'value_used': 'Value used',
    'of_which_medicines_x': 'Of which medicines and consumables {amount}',
    'value_not_used': 'Value not used',
    'overruns_billed': 'Billed beyond packages',
    'credited_on_cancellation': 'Credited on cancellation',
    'no_packages_sold_in_this_period': 'No packages were sold in this period.',
    'medicines_allowance_used': 'Medicines allowance used',
    'rows_x_to_y_of_z': '{first}–{last} of {total}',
    'previous_page': 'Previous page',
    'medicines_allowance': 'Medicines and consumables allowance',
    'medicines_allowance_hint': 'Medicines and consumables billed on the visit or the admission are covered up to this amount before tax; the rest is billed normally. Leave it empty for none.',
    'allowance_used_x_of_y_left_z': '{used} used of {total}, {left} left',
    'medicines_up_to_x': 'Medicines and consumables up to {amount}',
    'beyond_package': 'Beyond package',
    'take_a_package_line_off_the_bill': 'Take a package line off the bill',
    'a_package_line_carries_no_money_removing_it_gives': 'This line was used from the patient’s package and carries no charge. Taking it off gives the service back to the package; nothing is refunded.',
    'collect_x_for_y': 'Collect {number} ({kind})',
    'dues_orders_lab': 'lab',
    'dues_orders_radiology': 'imaging',
    'dues_orders_other': 'orders',
    'dues_includes_orders': 'includes {amount} for orders',
    'dues_visit_statement': 'Visit statement',
};
//# sourceMappingURL=billing.js.map